import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { FiMail, FiLock, FiUser } from 'react-icons/fi';
import { authService, lraService } from '../services/apiService';
import { useAuthStore } from '../store/authStore';

const Login = () => {
  const navigate = useNavigate();
  const setAuth = useAuthStore((state) => state.setAuth);

  const [formData, setFormData] = useState({
    email: '',
    password: '',
    dssn: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email || !formData.password || !formData.dssn) {
      setError('All fields are required');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await authService.login(
        formData.email,
        formData.password,
        formData.dssn
      );

      if (response.success) {
        setAuth(response.token, response.user);

        let isLRAUser = false;

        try {
          const lraResponse = await lraService.getMe();
          if (lraResponse.success && lraResponse.data) {
            useAuthStore.getState().setLRAUser(lraResponse.data);
            isLRAUser = true;
            toast.success(
              `Welcome, ${lraResponse.data.first_name}! (${
                lraResponse.data.role
              }${lraResponse.data.role === 'officer' ? ' + merchant' : ''})`
            );
          } else {
            useAuthStore.getState().clearLRAUser();
            toast.success('Login successful!');
          }
        } catch (lraErr) {
          // 403 = not an LRA user — merchant only
          useAuthStore.getState().clearLRAUser();
          toast.success('Login successful!');
        }

        // Default landing: LRA users → LRA portal, merchants → merchant portal
        if (isLRAUser) {
          useAuthStore.getState().setActiveView('lra');
          navigate('/lra/intelligence');
        } else {
          useAuthStore.getState().setActiveView('merchant');
          navigate('/dashboard');
        }
      } else {
        setError(response.message || 'Login failed');
      }
    } catch (err) {
      setError(
        err.response?.data?.error ||
          err.response?.data?.message ||
          err.message ||
          'Login failed. Please try again.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">LRA</div>
        <h1 className="login-title">LRA Inventory</h1>
        <p className="login-subtitle">Liberia Revenue Authority</p>

        {error && <div className="login-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email or Phone</label>
            <div style={{ position: 'relative' }}>
              <FiMail
                style={{
                  position: 'absolute',
                  left: '14px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#9ca3af',
                }}
              />
              <input
                type="text"
                name="email"
                className="form-input"
                style={{ paddingLeft: '40px' }}
                placeholder="Enter email or phone"
                value={formData.email}
                onChange={handleChange}
                disabled={loading}
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">DSSN</label>
            <div style={{ position: 'relative' }}>
              <FiUser
                style={{
                  position: 'absolute',
                  left: '14px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#9ca3af',
                }}
              />
              <input
                type="text"
                name="dssn"
                className="form-input"
                style={{ paddingLeft: '40px' }}
                placeholder="Enter your DSSN"
                value={formData.dssn}
                onChange={handleChange}
                disabled={loading}
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <div style={{ position: 'relative' }}>
              <FiLock
                style={{
                  position: 'absolute',
                  left: '14px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#9ca3af',
                }}
              />
              <input
                type="password"
                name="password"
                className="form-input"
                style={{ paddingLeft: '40px' }}
                placeholder="Enter password"
                value={formData.password}
                onChange={handleChange}
                disabled={loading}
              />
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            style={{ width: '100%', justifyContent: 'center', padding: '12px' }}
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <p
          style={{
            textAlign: 'center',
            marginTop: '24px',
            fontSize: '12px',
            color: '#9ca3af',
          }}
        >
          Version 1.0.0
        </p>
      </div>
    </div>
  );
};

export default Login;
